<template>
  <v-container>
    <template v-if="show == 'thanks'">
      <div class="title-icon top">
        <h1>{{ $t("labels.thanks") }}</h1>
        <v-btn
          icon
          :href="links.ebook.pauses"
          target="_blank"
        >
          <v-icon>$sl-question</v-icon>
        </v-btn>
      </div>
      <p>
        {{ $t("company.paused-text4", { name: apprenticeModel.text }) }}
      </p>
    </template>
    <template v-else>
      <div class="title-icon top">
        <h1>{{ $t("labels.pause-application") }}</h1>
        <v-btn
          icon
          :href="links.ebook.pauses"
          target="_blank"
        >
          <v-icon>$sl-question</v-icon>
        </v-btn>
      </div>
      <p>
        {{ $t("company.paused-text2") }}
      </p>

      <p v-if="get(apprenticeModel, 'bookId', -1) !== -1">
        <b>{{ $t('company.paused-text7') }}</b>
      </p>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-select
          v-model="apprenticeModel"
          :items="apprentices"
          :rules="rules.require"
          :label="$t('company.paused-dropdown-title')"
          :placeholder="$t('ebook.apprentice-list-title')"
          item-text="text"
          item-value="id"
          append-icon="$sl-arrow-down"
          outlined
          return-object
        >
          <template v-slot:selection="data">
            {{ data.item.text + data.item.personno }}<br />{{ data.item.profession }}
          </template>
          <template v-slot:item="data">
            <div>
              {{ data.item.text + data.item.personno }}<br />{{ data.item.profession }}
            </div>
          </template>
        </v-select>
        <DatePicker
          :icon="'$sl-calendar'"
          :label="$t('company.startFrom')"
          :required="true"
          :miniumDate="maxBackdate"
          :isDisabled="startDateDisabled"
          v-model="apprentice.startDate"
          :placeholder="$t('application.instructor.date.date-placeholder')"
        />

        <DatePicker
          :required="true"
          :miniumDate="apprentice.startDate"
          :icon="'$sl-calendar'"
          :label="$t('company.until')"
          v-model="apprentice.endDate"
          :placeholder="$t('application.instructor.date.date-placeholder')"
        />

        <v-textarea
          name="input-7-4"
          rows="10"
          v-model="textarea"
          :placeholder="this.$t('company.paused-textarea-text')"
          outlined
          :rules="[rules.required]"
          :label="$t('company.paused-textarea-label')"
        ></v-textarea>
        <p class="small mb-8">
          {{ $t("company.paused-text3") }}
        </p>

        <div v-for="(file, index) in selectedFiles" :key="index">
          <v-text-field
            :value="file.name"
            prepend-icon=""
            readonly
            :append-outer-icon="!isImitatingUser() ? '$sl-delete' : null"
            class="mt-n4"
            outlined
            :label="$t('labels.label-upload-file')"
            @click:append-outer="showDeleteModal(file)"
          ></v-text-field>
        </div>

        <ModalBase
            :show="showModal"
            maxWidth="400px"
            :title="$t('application.documents.delete-file')"
            cancelIcon="$sl-cancel"
            submitIcon="$sl-delete"
            cancelText="Avbryt"
            submitText="Radera"
            @close="closeModal"
            @cancel="closeModal"
            @submit="deleteFile"
            :outlinedCancel="false"
        />

        <!-- :rules="uploadRules" -->
        <v-form ref="uploadForm" v-model="valid1" lazy-validation>
          <v-file-input
            accept=".pdf, .jpg, .tiff, .png"
            ref="inputUpload1"
            v-model="files"
            class="d-none"
            @change="saveFiles"
          ></v-file-input>
        </v-form>

        <ActionButton
          class="mb-12 mt-n3"
          @click="$refs.inputUpload1.$refs.input.click()"
          type="application"
          actionIcon="$sl-attachment"
          :isDisabled="isImitatingUser()"
          >{{ $t("labels.btn-upload-file") }}</ActionButton
        >
        <ActionButton
          class=""
          @click="applyPause()"
          :isDisabled="apprenticeModel.id < 1 || isImitatingUser()"
          actionIcon="$sl-pause"
          >{{ $t("labels.pause-application-btn") }}</ActionButton
        >
      </v-form>
    </template>

    <v-dialog v-model="pauseTheoryModalVisible" max-width="400px">
      <v-card flat>
        <v-icon class="close" @click="pauseTheoryModalVisible = false">$sl-close</v-icon>
        <h2>
          {{ $t('dialog.pauseTitle') }}
        </h2>
        <p class="pt-2">{{ $t('dialog.pauseQuestion') }}</p>
      </v-card>
      <div class="d-flex justify-end pb-2 pt-4">
          <ActionButton
            :block="false"
            smallerText
            class="mr-2"
            type="application"
            actionIcon="$sl-cancel"
            @click="pauseTheoryCourses = false; save();"
          >{{ $t('labels.no') }}</ActionButton>
          <ActionButton
            :block="false"
            smallerText
            actionIcon="$sl-like"
            @click="pauseTheoryCourses = true; save()"
          >{{ $t('labels.yes') }}</ActionButton>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
import API from "@/services/api.js";
import ActionButton from "@/components/Common/ActionButton";
import { RulesMixin } from "@/components/mixins";
import ModalBase from '@/components/Common/ModalBase';
import DatePicker from "@/components/Common/DatePicker";
import { mapGetters } from "vuex";
import ModalBaseMixin from "@/components/mixins/ModalBaseMixin";
import SugarDate from 'sugar'
import get from 'lodash/get';

// @group Company
// CompanyPausedPerson component
export default {
  mixins: [RulesMixin, ModalBaseMixin],

  name: "CompanyPausedPerson",

  components: {
    ActionButton,
    DatePicker,
    ModalBase,
  },
  props: {
    //-1 = new
    // selectedBookPaused: {
    //   type: Object,
    //   default: {id: -1}
    // }
  },

  data: () => ({
    links: require('../../lib/external-links.json'),
    valid: true,
    valid1: true,
    show: "",
    uploadRules: [
      (value) =>
        !value || value.size < 1000000 || "Filstorleken måste vara mindre än 10 MB",
    ],
    apprentices: [],
    apprentice: {},
    startDateDisabled: false,
    apprenticeModel: { id: -1 },
    textarea: "",
    fileName: "",
    uploadfile: "",
    files: [],
    endEndDate: "",
    oldStartDate: "",
    isLoading: false,
    selectedFiles: [],
    pauseTheoryModalVisible: false,
    pauseTheoryCourses: false
  }),

  mounted() {
    this.$scrollToTop();
  },
  watch: {},

  created() {
    this.init();
  },
  /**
   * @vuese
   * Used to display fullName

   */
  filters: {},

  computed: {
    ...mapGetters("currentuser", [
      "currentUser",
      "isCompanyUser",
      "isApprentice",
      "isAdminUser",
      "isImitatingUser",
    ]),

    maxBackdate() {
      return SugarDate.Date().addMonths(-18).raw.toISOString()
    }
  },

  methods: {
    applyPause() {
      if(this.apprenticeModel?.bookId !== -1) {
        this.pauseTheoryModalVisible = true
      } else {
        this.save()
      }
    },
    
    get,

    /**
     * @vuese
     * Used to call method  getApprenticeById or  getEmployeeById based on route name
     * @arg called with no argument
     */
    init() {
      this.getApprentices();

      this.apprentice = {
        id: -1,
        startDate: String(new Date()),
        endDate: String(new Date()),
      };
    },
    formatPnr(no) {
      if (no && no.length == 12) return " (" + no.substr(2, 6) + ")";
      else return " (" + no + ")";
    },
    getApprentices() {
      if (!(this.$route && this.$route.params && this.$route.params.id)) return;      
      
      //to list all the apprentices in GU
      API.listBooks({ companyId: this.$route.params.id })
        .then((response) => {
          response.data.forEach((obj) => {
            this.apprentices.push({
              text: obj.person.firstName + " " + obj.person.lastName,
              id: 'book_' + obj.id,
              bookId: obj.id,
              educationId: -1,
              profession: obj.profession.name,
              personno: (obj.person && obj.person.personalNumber) ? this.formatPnr(obj.person.personalNumber) : '-1',
            });
            
          });   
        })
        .catch((error) => {
          console.log("There was an error:", error);
        });

      //to list all the apprentices in qualification time
      API.listEmployments(this.$route.params.id, {type: 'apprentice'})
        .then((response) => {
          response.data.forEach((obj) => {
            if(obj.education && obj.education.basicEducationCertificate!=null){

              this.apprentices.push({
                text: obj.apprentice.firstName + " " + obj.apprentice.lastName,
                bookId: -1,
                id: 'edu_' + obj.id,
                educationId: obj.education.id,
                profession: obj.profession.name,
                // personno: this.formatPnr('198610109996'),
                personno: (obj.apprentice && obj.apprentice.personalNumber) ? this.formatPnr(obj.apprentice.personalNumber) : '-1',
              });
              
            }
          });          
        })
        .catch((error) => {
          console.log("There was an error:", error);
        });
    },
    /**
     * @vuese
     * Used to push a file to array an display it
     * @arg The argument is an object representing file
     */
    saveFiles(file) {      
      if (!file) {
        return;
      }
      if (!this.$refs.uploadForm.validate()) {
        this.$events.fire("showError", this.$t("errors.save-document-size"));
        return;
      }
      this.isLoading = true;
      //used only to display
      this.selectedFiles.push(file);
      this.files = {};
      this.addNewFile = false;
      this.isLoading = false;
    },
    /**
     * @vuese
     * Used to delete a file from files array
     */
    async deleteFile() {
      this.showModal = false;
      if (!this.selectedItem) return;

      this.selectedFiles.splice(this.selectedFiles.indexOf(this.selectedItem), 1);
      this.selectedFiles = [...this.selectedFiles];
      this.files = {};
      this.$refs.uploadForm.reset();
    },

    /**
     * @vuese
     * Used to save all the files selected  and create a new exemption
     * @arg The argument is an array of files
     */
    save() {  
      // Make sure to close modal
      if(this.pauseTheoryModalVisible) {
        this.pauseTheoryModalVisible = false
      }

      if (!this.$refs.form.validate()) {
        this.$events.fire("showError", this.$t("errors.form-validation"));
        return;
      }
      if(SugarDate.Date.isAfter(new Date(this.apprentice.startDate), new Date(this.apprentice.endDate)) || this.apprentice.startDate==this.apprentice.endDate)
      {
        this.$events.fire("showError", this.$t("errors.form-date"))
        return;
      }
      if (this.apprenticeModel &&
        ((this.apprenticeModel.educationId && this.apprenticeModel.educationId>0) 
        || (this.apprenticeModel.bookId && this.apprenticeModel.bookId>0))) {
        let promises = [];
        this.selectedFiles.forEach((file) => {
          let nP = new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = () => {
              resolve({ data: reader.result, name: file.name, size: file.size });
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
          });
          promises.push(nP);
        });

        Promise.all(promises)
          .then((dataUrls) => {
            let prepareDataUrls = [];
            dataUrls.forEach((dataUrl) => {
              prepareDataUrls.push({
                data: dataUrl.data,
                name: dataUrl.name,
                size: dataUrl.size,
              });
            });
            let params = {
              startDate: this.apprentice.startDate,
              endDate: this.apprentice.endDate,
              reason: this.textarea,
              addDocuments: prepareDataUrls,
              employmentRate: 0.0,
              shouldPauseTheoryCourse: !!this.pauseTheoryCourses
            };            
        
            if (this.apprenticeModel.educationId && this.apprenticeModel.educationId>0)
              params.educationId=this.apprenticeModel.educationId
            else if (this.apprenticeModel.bookId && this.apprenticeModel.bookId>0)
              params.bookId=this.apprenticeModel.bookId

            API.createPauseBook({
              data: params,
            })
              .then((response) => {
                this.show = "thanks";
                this.isLoading = false;
              })
              .catch((error) => {                
                this.$events.fire("showError", this.$t("errors.save-failure"));
                this.isLoading = false;
              });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>
